import { COMMUNICATION_CHANNELS, COMMUNICATION_EVENTS, KEYLOCKER_COMMUNICATION_EVENT_TYPE } from "models";

export const isSms = (channel: COMMUNICATION_CHANNELS) => channel === COMMUNICATION_CHANNELS.SMS;
export const isOnlineCheckInAnswered = (eventType: COMMUNICATION_EVENTS | null) => eventType === COMMUNICATION_EVENTS.OnlineCheckInAnswered;
export const isDiagnoseOverviewAnswered = (eventType: COMMUNICATION_EVENTS | null) => eventType === COMMUNICATION_EVENTS.DiagnoseOverviewAnswered;

export const isDiagnoseOverviewSentResentAnswered = (eventType: COMMUNICATION_EVENTS | null) =>
  eventType
    ? [COMMUNICATION_EVENTS.DiagnoseOverviewSent, COMMUNICATION_EVENTS.DiagnoseOverviewResent, COMMUNICATION_EVENTS.DiagnoseOverviewAnswered].includes(eventType)
    : false;

export const isOnlineCheckInSentAnswered = (eventType: COMMUNICATION_EVENTS | null) =>
  eventType ? [COMMUNICATION_EVENTS.OnlineCheckInSent, COMMUNICATION_EVENTS.OnlineCheckInAnswered].includes(eventType) : false;

export const isRepairOverviewSentResent = (eventType: COMMUNICATION_EVENTS | null) =>
  eventType ? [COMMUNICATION_EVENTS.RepairOverviewSent, COMMUNICATION_EVENTS.RepairOverviewResent].includes(eventType) : false;

export const isRepairOrDiagnoseOverviewSentResent = (eventType: COMMUNICATION_EVENTS | null) =>
  eventType
    ? [
        COMMUNICATION_EVENTS.DiagnoseOverviewSent,
        COMMUNICATION_EVENTS.DiagnoseOverviewResent,
        COMMUNICATION_EVENTS.RepairOverviewSent,
        COMMUNICATION_EVENTS.RepairOverviewResent
      ].includes(eventType)
    : false;

export const isKeylockerDropPinOrPickupPinSent = (keylockerCommEventType: KEYLOCKER_COMMUNICATION_EVENT_TYPE | null) =>
  keylockerCommEventType ? [KEYLOCKER_COMMUNICATION_EVENT_TYPE.DropPINSent, KEYLOCKER_COMMUNICATION_EVENT_TYPE.PickUpPINSent].includes(keylockerCommEventType) : false;

export const stripHtml = (html: string) => {
  const tmpDivElement = document.createElement("div");
  tmpDivElement.innerHTML = html;

  return tmpDivElement.textContent || tmpDivElement.innerText || "";
};
